// TopSellingApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'TopSelling'];

// Enhance the base API service by adding entication-related tag types
const TopSellingApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
        
      // Fetch TopSelling query (GET request to /me)
      getTopSelling: build.query({
        query: () => ({
          url: `/topSellings`,
        }),
        providesTags: ['TopSelling'],
      }),  
     
       
    }),
    overrideExisting: false,
  });

export default TopSellingApi;

// Exporting hooks for each endpoint to be used in components
export const {
     useGetTopSellingQuery,
 } = TopSellingApi;


